import { styled } from "../../../styled-components";

export const OverlayEditorViewStyle = styled.label`
    display: flex;
    flex-direction: column;

    flex-grow: 1;
    align-items: stretch;
    padding: 5px 30px 0px 30px;
`;
